import { render, staticRenderFns } from "./ProformDataTableAdmin.vue?vue&type=template&id=2688f0b6&scoped=true"
import script from "./ProformDataTableAdmin.vue?vue&type=script&lang=js"
export * from "./ProformDataTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688f0b6",
  null
  
)

export default component.exports